export enum TravelDocumentEnum {
  LIST,
  DEFAULT,
}
